import React from 'react';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import { Box } from '@mui/material';
import { IMAGE_TYPES } from 'constants/images';

export const styles = {
  imageContainer: {
    padding: '4px 0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '200px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    cursor: 'pointer',
    borderRadius: '4px',
  },
  spanUpload: {
    color: '#626262',
    fontSize: 12,
    marginTop: 4,
  },
  disabled: {
    backgroundColor: '#ededed',
  },
  small: {
    color: '#4a4a4a',
    fontStyle: 'italic',
    marginTop: 4,
    display: 'block',
    fontFamily: 'AvenirNext',
    fontSize: 13,
  },
};

// For backwards compatibility
export const useStyles = () => styles;

function MuiUploadImage({ handleChange, subTitle, disabled, maxSize, fieldName }) {
  return (
    <div>
      <Box
        component="label"
        htmlFor={`attachment_${fieldName}`}
        sx={{ ...styles.imageContainer, ...(disabled && styles.disabled) }}
      >
        <AddAPhotoIcon />
        {subTitle && <Box component="span" sx={styles.spanUpload}>{subTitle}</Box>}
        {maxSize && <Box component="small" sx={styles.small}>Max size: {maxSize}Mb</Box>}
      </Box>
      <input
        type="file"
        hidden
        id={`attachment_${fieldName}`}
        accept={IMAGE_TYPES.join(', ')}
        onChange={(e) => handleChange(e)}
        disabled={disabled}
      />
    </div>
  );
}

export default MuiUploadImage;
